/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_Auto_HintInputs */

const cs_matches_auto_hint = /** @type {(inputs: Matches_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Párování se spouští i automaticky při publikaci nemovitosti nebo uložení poptávky.`)
};

const en_matches_auto_hint = /** @type {(inputs: Matches_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching also runs automatically when a listing is published or a demand is saved.`)
};

/**
* | output |
* | --- |
* | "Matching also runs automatically when a listing is published or a demand is saved." |
*
* @param {Matches_Auto_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_auto_hint = /** @type {((inputs?: Matches_Auto_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_Auto_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_auto_hint(inputs)
	return cs_matches_auto_hint(inputs)
});